import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './driver/contexts/AuthContext';
import DriverLayout from './driver/layouts/DriverLayout';
import WorkPage from './driver/pages/WorkPage';
import DeliveryDetailPage from './driver/pages/DeliveryDetailPage';
import AlertsPage from './driver/pages/AlertsPage';
import EarningsPage from './driver/pages/EarningsPage';
import HistoryPage from './driver/pages/HistoryPage';
import DeliveryHistoryDetailPage from './driver/pages/DeliveryHistoryDetailPage';
import ProfilePage from './driver/pages/ProfilePage';
import WelcomePage from './driver/pages/WelcomePage';

// Mounted at /driver/* in the host app router.
export default function DriverPortal() {
  return (
    <AuthProvider>
      <Routes>
        <Route element={<DriverLayout />}>
          <Route index element={<Navigate to="work" replace />} />
          <Route path="work" element={<WorkPage />} />
          <Route path="delivery/:orderId" element={<DeliveryDetailPage />} />
          <Route path="alerts" element={<AlertsPage />} />
          <Route path="earnings" element={<EarningsPage />} />
          <Route path="history" element={<HistoryPage />} />
          <Route path="history/:orderId" element={<DeliveryHistoryDetailPage />} />
          <Route path="profile" element={<ProfilePage />} />
          <Route path="welcome" element={<WelcomePage />} />
        </Route>
        <Route path="*" element={<Navigate to="work" replace />} />
      </Routes>
    </AuthProvider>
  );
}
